
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { DeleteConfirmationProps } from "./types";

export function DeleteConfirmation({ isOpen, onCancel, onConfirm }: DeleteConfirmationProps) {
  if (!isOpen) return null;
  
  return (
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Sei sicuro?</AlertDialogTitle>
        <AlertDialogDescription>
          Questa azione non può essere annullata. L'avviso di prezzo verrà eliminato permanentemente.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel}>Annulla</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm}>Elimina</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
}
